import React from 'react';
import {
  Card,
  Modal,
  Row,
  Col,
  Button,
  Label,
} from 'reactstrap';

import ActionDetailCard from './ActionDetailCard';

const ModalTrash = (props) => {
  const {
    modalTrashControl,
    setModalTrashControl,
    eventSchedules,
    guestGroups,
    getTypeText,
    setModalLogControl,
  } = props;

  const handleClose = () => {
    setModalTrashControl({ ...modalTrashControl, open: false });
  };

  return (
    <Modal isOpen={modalTrashControl.open} toggle={handleClose}>
      <Card style={{ padding: 5, minWidth: window.innerWidth < 350 ? null : 300 }}>
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-end">
          <Col xs="auto">
            <Button close onClick={handleClose} />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-center">
          <Col lg={12}>
            <Label style={{ color: 'black' }}>Excluidos</Label>
          </Col>
        </Row>
        <Col style={{ marginTop: 5 }}>
          {renderActionsList()}
        </Col>
      </Card>
    </Modal>
  );

  function renderActionsList() {
    if (modalTrashControl.actions.length <= 0) {
      return (
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-center">
          <Label style={{ color: 'black' }}>Nenhum resultado encontrado</Label>
        </Row>
      )
    }
    return (
      <>
        {modalTrashControl.actions.map(a => {
          return (
            <Row key={a.id} style={{ marginBottom: 10 }} className="d-flex justify-content-center">
              <Card body style={{ backgroundColor: '#e8eced', width: '100%', maxWidth: 600 }}>
                <ActionDetailCard
                  action={a}
                  eventActions={modalTrashControl.actions}
                  eventSchedules={eventSchedules}
                  guestGroups={guestGroups}
                  getTypeText={getTypeText}
                />
                <Row>
                  <Col>
                    <Button color="link" onClick={() => setModalLogControl({ open: true, action: a })}>
                      <i className="fa fa-info-circle" /> <Label style={{ color: 'black' }}>Log</Label>
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Row>
          )
        })}
      </>
    )
  }
};

export default ModalTrash;
